export default __webpack_public_path__ + "static/media/waitlist-delete.856e3348.svg";